module.exports = __webpack_public_path__ + "img/facebook.ed782762.svg";